import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReference = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 40,
			cy: 40,
			r: 40,
			fill: "#FFF6E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M64.2857 42.5418C64.2857 27.9245 53.4126 17.7891 40 17.7891C26.5874 17.7891 15.7143 27.53 15.7143 42.5418C15.7143 46.5833 16.7624 51.9382 20.5949 56.8542C21.1029 57.5058 21.8965 57.8577 22.7227 57.8577H57.3359C58.1592 57.8577 58.9512 57.5088 59.4547 56.8573C62.7515 52.5916 64.2857 47.2716 64.2857 42.5418Z",
			fill: "#F6A500"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M61.9384 42.0908C61.9384 29.9745 52.1162 20.1523 40 20.1523C27.8837 20.1523 18.0615 29.9745 18.0615 42.0908C18.0615 47.1823 19.7962 51.8686 22.7066 55.5913H57.2934C60.2037 51.8686 61.9384 47.1823 61.9384 42.0908Z",
			fill: "#E4EBF7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M61.9384 42.0908C61.9384 29.9745 52.1162 20.1523 40 20.1523C27.8837 20.1523 18.0615 29.9745 18.0615 42.0908C18.0615 47.1823 19.7962 51.8686 22.7066 55.5913H57.2934C60.2037 51.8686 61.9384 47.1823 61.9384 42.0908Z",
			fill: "#FBD68B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M40.0188 26.455C39.5029 26.455 39.0848 26.0368 39.0848 25.5209V23.6528C39.0848 23.137 39.5029 22.7188 40.0188 22.7188C40.5347 22.7188 40.9529 23.137 40.9529 23.6528V25.5209C40.9529 26.0368 40.5347 26.455 40.0188 26.455Z",
			fill: "#F6A500"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M27.8035 31.4975C27.4387 31.8624 26.8473 31.8624 26.4825 31.4975L25.1615 30.1766C24.7968 29.8118 24.7968 29.2204 25.1615 28.8556C25.5263 28.4908 26.1177 28.4908 26.4825 28.8556L27.8035 30.1766C28.1682 30.5414 28.1682 31.1327 27.8035 31.4975Z",
			fill: "#F6A500"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.4776 42.5415C23.4776 43.0573 23.0594 43.4756 22.5435 43.4756H20.6754C20.1595 43.4756 19.7413 43.0573 19.7413 42.5415C19.7413 42.0257 20.1595 41.6074 20.6754 41.6074H22.5435C23.0594 41.6074 23.4776 42.0257 23.4776 42.5415Z",
			fill: "#F6A500"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M56.5224 42.5415C56.5224 42.0257 56.9406 41.6074 57.4565 41.6074H59.3246C59.8404 41.6074 60.2587 42.0257 60.2587 42.5415C60.2587 43.0573 59.8404 43.4756 59.3246 43.4756H57.4565C56.9406 43.4756 56.5224 43.0573 56.5224 42.5415Z",
			fill: "#F6A500"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M52.1966 30.1766L53.5175 28.8556C53.8823 28.4908 54.4737 28.4908 54.8385 28.8556C55.2033 29.2204 55.2033 29.8118 54.8385 30.1766L53.5175 31.4975C53.1528 31.8624 52.5613 31.8624 52.1966 31.4975C51.8318 31.1327 51.8318 30.5414 52.1966 30.1766Z",
			fill: "#F6A500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.565 44.4318C42.8468 45.0239 43.7363 46.3208 43.7363 47.8255C43.7363 49.889 42.0635 51.5618 40 51.5618C37.9365 51.5618 36.2637 49.889 36.2637 47.8255C36.2637 46.2911 37.1888 44.9726 38.5116 44.3975L39.6623 34.5923C39.6905 34.3188 40.0858 34.3105 40.1256 34.5826L41.565 44.4318Z",
			fill: "#8D4A05"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.8682 47.8271C41.8682 48.8588 41.0318 49.6952 40 49.6952C38.9683 49.6952 38.1319 48.8588 38.1319 47.8271C38.1319 46.7954 38.9683 45.959 40 45.959C41.0318 45.959 41.8682 46.7954 41.8682 47.8271Z",
			fill: "#F6A500"
		})
	]
});
export default SvgReference;
